<template>
 <div>
   <game-title-layout :show-top="showTop"></game-title-layout>
   <div v-for="(mapTmp, key) in mapList" :key="key">
     <div class="gameImgArea">
       <div class="box" v-for="(item, index) in mapTmp" :key="index" :id="getLinesId(key,index)">
         <div :style="{
                    background: (item.length == 3 && item.substring(2, 3) == `W`)
                    ? `url(${require('../../assets/hunter/wbg.png')})` : ``
                    , 'background-size': '100% 100%'
                    , 'opacity': matchDeepColor(key, index) || ((scatterwin > 0) && (item == 'S')) ? 1 : 0.2
                  }" >
           <img :src="require('../../assets/hunter/' + (item.length >= 3 ? item.substring(0, 2) : item) + '.png')" alt=""  :class="{ deep: true }">
         </div>
       </div>
     </div>
     <div class="gameImgDetail">
       <div class="box" v-for="(item, index) in mapListDetail[key]" :key="index">
         <img :src="require('../../assets/hunter/' + item.key + '.png')" alt="" :class="{ deep: true }">
         <p>x {{item.lines}} ({{item.length}})</p>
         <p>{{item.winInfo}}</p>
       </div>
     </div>
   </div>
   <SlotsWinTotalLayout :show-total="true" :win-value-total="winValueTotal"></SlotsWinTotalLayout>
 </div>
</template>

<script>
import SlotsWinTotalLayout from "./layout/slots_win_total_layout.vue";
import GameTitleLayout from "../common/game_detail_title.vue";
import {slots_tool} from "./slots_tool";
export default {
  name: "Game5011",
  components: {
    SlotsWinTotalLayout,
    GameTitleLayout

  },
  props: {
    showTop: false,
    showTotal:false,
    winValueTotal:"",
    linesId:"S",
    mapList: [],
    mapIndex: [],
    mapListDetail: [],
    Phone:false,
  },
  methods: {
    matchDeepColor(index, subIndex)
    {
      return slots_tool.matchSubDeepColor(this.mapIndex,index,subIndex);
    },
    getLinesId(index,subIndex)
    {
      console.log("getLinesId")
      return slots_tool.setMapsLineIdName(this.linesId,index,subIndex);
    },
  }
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/slots/game_5011.vue